// Speedometer under the crosshair: horizontal speed in ups, optionally tinted
// (and marked with an arrow) by whether the speed is rising or falling, a
// small bar and the vertical speed.

import { el, setText } from './dom';

/** Bar is full at this speed. */
const BAR_MAX = 1200;

export class Speedometer {
  readonly root = el('div', 'hud-speed');
  private readonly value = el('span', 'hud-speed-value');
  private readonly trend = el('span', 'hud-speed-trend');
  private readonly fill = el('div', 'hud-speed-fill');
  private readonly vertical = el('div', 'hud-speed-z');
  private prev = 0;
  private accel = 0;
  private state = '';
  colorize = true;

  constructor() {
    const row = el('div', 'hud-speed-row');
    row.append(this.value, this.trend);
    const bar = el('div', 'hud-speed-bar');
    bar.appendChild(this.fill);
    this.root.append(row, bar, this.vertical);
  }

  update(speed: number, velocityZ: number): void {
    setText(this.value, String(Math.round(speed)));
    // smoothed change per frame: positive while gaining speed
    this.accel = this.accel * 0.85 + (speed - this.prev) * 0.15;
    this.prev = speed;
    const state = !this.colorize || speed < 1 ? '' : this.accel > 0.05 ? 'gain' : this.accel < -0.05 ? 'loss' : '';
    if (state !== this.state) {
      this.state = state;
      this.root.dataset.trend = state;
      setText(this.trend, state === 'gain' ? '▲' : state === 'loss' ? '▼' : '');
    }
    this.fill.style.transform = `scaleX(${Math.min(1, speed / BAR_MAX).toFixed(3)})`;
    setText(this.vertical, `${velocityZ >= 0 ? '↑' : '↓'} ${Math.abs(Math.round(velocityZ))}`);
  }
}
